<template>
    <div class="py-2 container-fluid">
        <div class="container">
            <div class="row">
                <div class="mx-auto col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <div class="d-flex justify-content-between">
                                <back-button class="me-2" />
                                <div class="text-center">
                                    <h6 class="mb-0">{{ isNew ? 'Novo Grupo de Empresa' : 'Editar Grupo de Empresa' }}
                                    </h6>
                                    <p class="mb-0 text-sm">{{ grupo.descricao }}</p>
                                </div>
                                <submit-button @click="salvar" :label="isNew ? 'Criar' : 'Salvar'" :loading="loading" />
                            </div>
                        </div>
                        <div class="card-body">
                            <!-- Campo de descrição -->
                            <div class="row mb-4">
                                <div class="col-md-9">
                                    <div class="form-group">
                                        <label for="descricao">Descrição</label>
                                        <argon-input id="descricao" type="text" placeholder="Descrição"
                                            v-model="grupo.descricao" :success="isSaved" :error="errors.descricao"
                                            autocomplete="off" text-case="upper" />
                                        <div class="invalid-feedback" v-if="errors.descricao">
                                            {{ errors.descricao }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="status">Status</label>
                                        <select class="form-control" id="status" v-model="grupo.status">
                                            <option :value="1">Ativo</option>
                                            <option :value="0">Inativo</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <hr class="mt-2 mb-4 dark">

                            <!-- Lista de empresas -->
                            <div class="row">
                                <div class="col-12">
                                    <div class="d-flex justify-content-between mb-3">
                                        <div>
                                            <h6>Empresas do Grupo</h6>
                                        </div>
                                        <span class="font-weight-bold text-dark">
                                            <argon-button color="primary" size="sm" :full-width="true"
                                                variant="contained" data-bs-toggle="modal"
                                                data-bs-target="#modal-selecionar-empresa">
                                                Adicionar
                                                <i class="fas fa-plus"></i>
                                            </argon-button>
                                        </span>
                                    </div>

                                    <div v-if="grupo.empresas && grupo.empresas.length > 0">
                                        <table id="products-list" class="table table-flush">
                                            <thead class="thead-light">
                                                <tr>
                                                    <th>ID</th>
                                                    <th>Empresa</th>
                                                    <th>Cidade</th>
                                                    <th>Status</th>
                                                    <th class="text-center">Ações</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item, index) in grupo.empresas" :key="index">
                                                    <td>
                                                        <h4 class="my-auto text-xs font-weight-bolder">
                                                            {{ item.empresa?.id }}
                                                        </h4>
                                                    </td>
                                                    <td>
                                                        <h6 class="my-auto text-xs">
                                                            {{ item.empresa?.nomeFantasia }}
                                                        </h6>
                                                    </td>
                                                    <td>
                                                        <h6 class="my-auto text-xs">
                                                            {{ formatarCidade(item.empresa?.cidade) }}
                                                        </h6>
                                                    </td>
                                                    <td>
                                                        <h6 class="my-auto">
                                                            <badge-status :ativo="true" size="xs" />
                                                        </h6>
                                                    </td>
                                                    <td class="text-sm text-center">
                                                        <argon-button color="danger" size="xs"
                                                            @click="removerItem(index)">
                                                            Excluir
                                                        </argon-button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div v-else class="text-center py-4">
                                        <p class="text-sm mb-0">Nenhuma empresa adicionada ao grupo</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Usando o componente de modal para seleção de empresas -->
        <empresa-seletor-modal :empresas-ja-selecionadas="grupo.empresas" :search="search"
            @update:search="search = $event" @adicionar-empresa="adicionarEmpresa" />
    </div>
</template>

<script>
import api from '@/services/api';
import ArgonInput from '@/components/ArgonInput.vue';
import ArgonButton from '@/components/ArgonButton.vue';
import SubmitButton from '@/components/SubmitButton.vue';
import BackButton from '@/components/BackButton.vue';
import EmpresaSeletorModal from './components/EmpresaSeletorModal.vue';
import BadgeStatus from '@/views/pages/components/BadgeStatus.vue';
import { successToast, errorToast, showConfirm } from '@/utils/alerts';

export default {
    name: 'GrupoEmpresa',
    components: {
        ArgonInput,
        ArgonButton,
        SubmitButton,
        BackButton,
        EmpresaSeletorModal,
        BadgeStatus
    },
    inject: ['filters'],
    data() {
        return {
            id: this.$route.params.id,
            grupo: {
                descricao: '',
                status: 1,
                empresas: []
            },
            search: '',
            errors: {},
            loading: false,
            isSaved: false,
            empresasInfo: [] // Para armazenar informações das empresas para exibição
        };
    },
    computed: {
        isNew() {
            return this.id === 'new';
        }
    },
    mounted() {
        this.carregarInformacoesEmpresas();
        if (!this.isNew) {
            this.fetchData();
        }
    },
    methods: {
        carregarInformacoesEmpresas() {
            api.get('/clientes/empresas-hotel')
                .then(response => {
                    this.empresasInfo = response.data;
                })
                .catch(e => {
                    console.log(e);
                });
        },
        formatarCidade(cidade) {
            // Verifica se a cidade existe
            if (!cidade) return '-';

            // Se cidade é um objeto com a propriedade descricao
            if (typeof cidade === 'object' && cidade.descricao) {
                if (cidade.uf) {
                    return `${cidade.descricao}/${cidade.uf.uf}`;
                }
                return cidade.descricao;
            }

            // Se cidade é uma string
            return cidade;
        },
        formatDate(date) {
            if (!date) return '-';
            return this.filters.formatDateTime(date, 'DD/MM/YY HH:mm');
        },
        fetchData() {
            this.loading = true;
            api.get(`/grupo-empresas/${this.id}`)
                .then(response => {
                    const { data } = response;
                    this.grupo = data;

                    // Garantir que empresas seja um array
                    if (!this.grupo.empresas) {
                        this.grupo.empresas = [];
                    }

                    this.loading = false;
                })
                .catch(e => {
                    console.log(e);
                    this.loading = false;
                });
        },
        salvar() {
            if (!this.grupo.descricao) {
                errorToast('A descrição é obrigatória');
                return;
            }

            // Converter descrição para maiúsculas antes de salvar
            this.grupo.descricao = this.grupo.descricao.toUpperCase();

            this.loading = true;
            this.errors = {};
            this.isSaved = false;

            const method = this.isNew ? 'post' : 'patch';
            const url = this.isNew ? '/grupo-empresas' : `/grupo-empresas/${this.id}`;

            api[method](url, this.grupo)
                .then(() => {
                    this.loading = false;
                    this.isSaved = true;

                    successToast('Grupo de empresa salvo com sucesso.');

                    // Redirecionar para a listagem após salvar com sucesso
                    setTimeout(() => {
                        this.$router.push({ name: 'GrupoEmpresas' });
                    }, 1000);
                })
                .catch(error => {
                    this.loading = false;

                    const { data } = error;

                    const { message } = data;

                    errorToast(message);
                });
        },
        adicionarEmpresa(empresa) {
            this.grupo.empresas.push({
                empresa: {
                    id: empresa.id,
                    razaoSocial: empresa.razao_social || empresa.razaoSocial,
                    nomeFantasia: empresa.nome_fantasia || empresa.nomeFantasia,
                    cnpj: empresa.cpf_cnpj || empresa.cnpj,
                    cidade: empresa.cidade
                }
            });
        },
        removerItem(index) {
            const item = this.grupo.empresas[index];
            const nomeEmpresa = item.empresa?.nomeFantasia || `Empresa ID: ${item.empresa?.id}`;

            showConfirm(`${item.empresa?.id} - ${nomeEmpresa}`, 'Confirma exclusão da empresa?')
                .then(confirmed => {
                    if (confirmed) {
                        this.grupo.empresas.splice(index, 1);
                    }
                });
        },
        getNomeEmpresa(empresaId) {
            const empresa = this.empresasInfo.find(e => e.id === empresaId);
            return empresa ? empresa.nome_fantasia : `Empresa ID: ${empresaId}`;
        }
    },
    watch: {
        search() {
            // O filtro é aplicado automaticamente no modal
        }
    }
};
</script>

<style lang="scss" scoped>
/* Estilos específicos */
</style>